import { Asterisk } from "lucide-react";

const WORDS = ["Furniture", "Appliances", "Hot Tubs", "Yard Waste", "Cleanouts", "Greenville SC", "Same Day Pickup", "Free Onsite Quote"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display whitespace-nowrap px-6 text-5xl uppercase text-[#0D0D0B] sm:text-7xl">{w}</span>
        <Asterisk className="h-8 w-8 text-[#0D0D0B]" strokeWidth={3} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee-ticker-container" className="relative z-10 -my-1 -rotate-[1.5deg] overflow-hidden border-y-4 border-[#0D0D0B] bg-[#FFB000] py-4">
    <div className="marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </div>
);
